<template>
  <div>
    <div class="c-form-filter l-block l-mt-3">
      <h3 class="c-form-filter__title">絞り込み</h3>
      <div class="c-form-filter__items">
        <div class="c-form-filter__item">
          <p class="c-form-filter__legend">月間検索数</p>
          <Inputs v-model="tmpFilter.searchVolume" @enter="updateFilter" />
        </div>

        <div class="c-form-filter__item">
          <p class="c-form-filter__legend">キーワード</p>
          <Input
            v-model="tmpFilter.keyword"
            placeholder=""
            @enter="updateFilter"
          />
        </div>
        <div class="c-form-filter__item">
          <p class="c-form-filter__legend">競合順位</p>
          <Inputs
            v-model="tmpFilter.competitorSiteRank"
            @enter="updateFilter"
          />
        </div>
        <div class="c-form-filter__item">
          <p class="c-form-filter__legend">競合URL</p>
          <Input
            v-model="tmpFilter.competitorSitePageUrl"
            placeholder=""
            @enter="updateFilter"
          />
        </div>
        <div class="c-form-filter__item">
          <p class="c-form-filter__legend">自社平均順位</p>
          <Inputs v-model="tmpFilter.ownSiteRank" @enter="updateFilter" />
        </div>
        <div class="c-form-filter__item">
          <p class="c-form-filter__legend">自社URL</p>
          <Input
            v-model="tmpFilter.ownSiteUrl"
            placeholder=""
            @enter="updateFilter"
          />
        </div>
      </div>
      <div class="c-form-filter__btns">
        <Button
          fsize="f12"
          variant="border"
          icon="pageback"
          @click="resetFilter"
        >
          初期値に戻す
        </Button>
        <Button fsize="f14" variant="main" @click="updateFilter">
          適用する
        </Button>
      </div>
    </div>
    <div class="p-competing-actions">
      <ul class="c-graph-legend">
        <li class="c-graph-legend__item c-graph-legend__item--hasTask">
          TODO・進行中にタスク登録済み
        </li>
        <li class="c-graph-legend__item c-graph-legend__item--completedTask">
          タスク完了済み
        </li>
      </ul>
    </div>
    <ListCompetitiveSiteKeyword
      :items="sortedItems"
      :project="project"
      :isLoading="data.isLoading"
      :surveyDate="data.surveyDate"
      :competitorSiteDomain="data.competitorSiteDomain"
      :tasks="data.onGoingTasks"
      :completedTasks="data.completedTasks"
      :gscError="data.isExpiredGscRefreshToken"
      :sort="sort"
      @sort="updateSort"
      @addedTasks="getTasks"
    />
  </div>
</template>

<script>
import Button from '@/components/Button';
import Input from '@/components/Input';
import Inputs from '@/components/Inputs';
import ListCompetitiveSiteKeyword from '@/components/competitiveSiteKeyword/ListCompetitiveSiteKeyword';
import apiProjects from '@/api/projects';
import utils from '@/utils';
import axios from 'axios';

export default {
  props: ['project'],
  components: {
    Button,
    Input,
    Inputs,
    ListCompetitiveSiteKeyword
  },

  data() {
    return {
      data: {
        items: [],
        competitorSiteDomain: '',
        surveyDate: '',
        isExpiredGscRefreshToken: false,
        isLoading: true,
        onGoingTasks: [],
        completedTasks: []
      },
      competitorSiteId: this.$route.params['competitorSiteId'],
      tmpFilter: {
        searchVolume: ['', ''],
        competitorSiteRank: ['', ''],
        ownSiteRank: ['', ''],
        keyword: '',
        competitorSitePageUrl: '',
        ownSiteUrl: ''
      },
      filter: {
        searchVolume: ['', ''],
        competitorSiteRank: ['', ''],
        ownSiteRank: ['', ''],
        keyword: '',
        competitorSitePageUrl: '',
        ownSiteUrl: ''
      },
      request: {
        cancelToken: null,
        expiresAt: Date.now() + 10 * 60 * 1000, //10分,
        timeoutDelay: 10 * 1000, //10秒
        timeoutId: null
      },
      sort: {
        name: 'competitorSiteRank',
        orderby: 'asc',
        type: 'number'
      }
    };
  },
  computed: {
    sortedItems() {
      let items = this.filteredItems.slice();
      return utils.sort(
        items,
        this.sort.type,
        this.sort.orderby,
        this.sort.name
      );
    },
    filteredItems() {
      return this.data.items.filter(item => {
        if (!this.isInRange(item.searchVolume, this.filter.searchVolume)) {
          return false;
        }
        if (
          !this.isInRange(
            item.competitorSiteRank,
            this.filter.competitorSiteRank
          )
        ) {
          return false;
        }
        if (!this.isInRange(item.ownSiteRank, this.filter.ownSiteRank)) {
          return false;
        }
        if (!this.isMatchedString(item.keyword, this.filter.keyword)) {
          return false;
        }
        if (
          !this.isMatchedString(
            item.competitorSitePageUrl,
            this.filter.competitorSitePageUrl
          )
        ) {
          return false;
        }
        if (
          !this.isMatchedOwnSiteUrl(item.ownSiteUrl, this.filter.ownSiteUrl)
        ) {
          return false;
        }
        return true;
      });
    }
  },
  created() {
    this.getKeywords();
  },
  destroyed() {
    clearTimeout(this.request.timeoutId);
    if (this.request.cancelToken) {
      this.request.cancelToken.cancel();
    }
  },
  methods: {
    getKeywords() {
      this.request.cancelToken = axios.CancelToken.source();

      apiProjects.competitorSites.keyword
        .get(
          this.auth.idToken,
          this.project.id,
          this.competitorSiteId,
          this.request.cancelToken.token
        )
        .then(response => {
          this.data.items = response.data.items;
          this.data.competitorSiteDomain = response.data.url;
          this.data.surveyDate = response.data.surveyDate;
          this.data.isExpiredGscRefreshToken = response.data.status === 10;
          this.data.isLoading = false;
          this.getTasks();
        })
        .catch(error => {
          if (!axios.isCancel(error)) {
            // ページアクセスから10分以内であれば再取得のタイマー設定
            if (Date.now() < this.request.expiresAt) {
              this.request.timeoutId = setTimeout(
                this.getKeywords,
                this.request.timeoutDelay
              );
            } else {
              this.data.isLoading = false;
            }
          }
        });
    },
    getTasks() {
      apiProjects.tasks
        .get(
          {
            columns: 'todo,doing,done',
            order: 'createdDate:asc'
          },
          this.auth.idToken,
          this.project.id
        )
        .then(response => {
          this.data.onGoingTasks = response.data.items.filter(
            item =>
              (item.column === 'todo' || item.column === 'doing') &&
              item.keyword
          );
          this.data.completedTasks = response.data.items.filter(
            item => item.column === 'done' && item.keyword
          );
        });
    },
    updateSort(sort) {
      this.sort = sort;
    },
    updateFilter() {
      this.filter = Object.assign({}, this.tmpFilter);
    },
    resetFilter() {
      this.tmpFilter = {
        searchVolume: ['', ''],
        competitorSiteRank: ['', ''],
        ownSiteRank: ['', ''],
        keyword: '',
        competitorSitePageUrl: '',
        ownSiteUrl: ''
      };
      this.updateFilter();
    },
    isInRange(value, filter) {
      if (!utils.isEmpty(filter[0]) && value < filter[0]) {
        return false;
      }
      if (!utils.isEmpty(filter[1]) && value > filter[1]) {
        return false;
      }
      return true;
    },
    isMatchedString(value, filter) {
      if (utils.isEmpty(filter)) {
        return true;
      }
      const str1 = utils.convertToSearchString(value);
      const str2 = utils.convertToSearchString(filter);
      if (str1.indexOf(str2) === -1) {
        return false;
      }
      return true;
    },
    isMatchedOwnSiteUrl(value, filter) {
      if (utils.isEmpty(filter)) {
        return true;
      }
      if (value == null) {
        return false;
      }
      const removedValue = this.$options.filters.removeDomain(
        value,
        this.project.siteUrl
      );
      const str = utils.convertToSearchString(filter);
      if (removedValue.indexOf(str) === -1) {
        return false;
      }
      return true;
    }
  }
};
</script>
